import { GET_SIDEBAR_HIDDER } from "../actionTypes";

export const SetSidebarHidder = (isActive) => {
  return async (dispatch) => {
    dispatch({ type: GET_SIDEBAR_HIDDER, payload: isActive });
  };
};
